



































import PassengerTransportationPermission from '@/views/PassengerTransportationPermission.vue';
import {Vue, Prop, Component, Watch} from 'vue-property-decorator';
@Component({
    components: {
      PassengerTransportationPermission
    }
})
export default class TransportationPermissionListItem extends Vue {
  @Prop({required: true}) permission!: IBookingQuotaWithPeriods;

  viewPermissionDialog: boolean = false;
  dialogOpener: HTMLElement | null = null;

  @Watch("viewPermissionDialog")
  viewPermissionDialogChanged(newValue: boolean) {
    if (newValue) {
      this.$store.commit('app/incrementOpenDialogCount');
      this.dialogOpener = document.activeElement as HTMLElement | null;
      this.$nextTick(() => {
        const dialog = this.$refs?.viewPermissionDialogRef as Vue | undefined;
        const content = dialog?.$refs?.content as HTMLElement | undefined;
        if (!content || !dialog || !dialog.$attrs) return;
        content.setAttribute('aria-label', dialog.$attrs['aria-label']);
        const innerVDialog = content.querySelector('.v-dialog');
        if (innerVDialog) innerVDialog.removeAttribute('tabindex');
        const heading = content.querySelector<HTMLElement>('#main-content');
        if (!heading) return;
        let tries = 0;
        const attempt = () => {
          if (!this.viewPermissionDialog) return;
          heading.focus();
          tries++;
          if (document.activeElement !== heading && tries < 30) {
            requestAnimationFrame(attempt);
          }
        };
        requestAnimationFrame(attempt);
      });
    } else {
      this.$store.commit('app/decrementOpenDialogCount');
      window.setTimeout(() => this.dialogOpener?.focus(), 100);
    }
  }

  get startDate() {
    if (this.permission) {
        return this.$moment(this.permission.startDate).format('DD.MM.YYYY');
    } 
    return '';
  }

  get endDate() {
    if (this.permission && this.permission.endDate) {
        return this.$moment(this.permission.endDate).format('DD.MM.YYYY');
      } 
    return '';
  }

}
